import { useAiTags } from '@solinkcorp/ai-tags';
import { useEffect } from 'react';
import { ServiceDisplayEventsController } from '../ServiceDisplayEventsController';

export default function useEventsControllerTagNamesSetter(
  eventsController: ServiceDisplayEventsController,
) {
  const { data: aiTags } = useAiTags();
  useEffect(() => {
    if (!aiTags) return;
    const namesById = new Map<string, string>();
    for (const tag of aiTags) {
      if (tag.id) namesById.set(tag.id, tag.name);
    }
    eventsController.setAiTagNames(namesById);
  }, [aiTags, eventsController]);
}
